import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/FetchAIPSkills';
// FOR ONE GRAPHQL QUERY
export const FETCH_AIP_SKILLS = defineAsyncActionTypes(`${prefix}/FETCH_AIP_SKILLS`);
